function redondeoPersonalizado(valor, limite, tope) {
    var modulo = valor % tope;
    //console.log('modulo es ' + modulo);
    if (modulo >= limite)
        return valor + tope - modulo;
    else
        return valor - modulo;
}
export default { redondeoPersonalizado }